export const METODOS_PAGAMENTO = [
  { id: 'pix', label: 'PIX', icon: 'QrCode' },
  { id: 'cartao', label: 'Cartão', icon: 'CreditCard' },
];

export const LABELS_BOTAO = {
  pix: 'Finalizar com PIX',
  cartao: 'Finalizar com Cartão',
};

export const ESTADO_INICIAL = {
  dadosBase: { nome: '', email: '', cpf: '', whatsapp: '' },
  cartao: { numero: '', nome: '', validade: '', cvv: '' },
};

export function validarCPF(cpf) {
  const d = cpf.replace(/\D/g, '');
  if (d.length !== 11) return false;
  if (/^(\d)\1{10}$/.test(d)) return false; // todos iguais (000.000.000-00, etc.)
  const calc = (len) => {
    let sum = 0;
    for (let i = 0; i < len; i++) sum += parseInt(d[i]) * (len + 1 - i);
    const r = (sum * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return calc(9) === parseInt(d[9]) && calc(10) === parseInt(d[10]);
}

export function aplicarMascara(valor, tipo) {
  // Guard: coerce non-strings (prevents crash on null/undefined)
  const v = String(valor ?? '').replace(/\D/g, '');

  const mascaras = {
    cpf: (s) => {
      const d = s.slice(0, 11);
      if (d.length <= 3) return d;
      if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
      if (d.length <= 9)
        return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
      return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
    },

    whatsapp: (s) => {
      const d = s.slice(0, 11);
      if (d.length <= 2) return d;
      if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
      return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    },

    // Field name in state is 'numero' — mask must match
    numero: (s) => {
      const d = s.slice(0, 16);
      return d.replace(/(\d{4})(?=\d)/g, '$1 ').trim();
    },

    validade: (s) => {
      const d = s.slice(0, 4);
      if (d.length <= 2) return d;
      return `${d.slice(0, 2)}/${d.slice(2)}`;
    },

    cvv: (s) => s.slice(0, 4),
  };

  return mascaras[tipo]?.(v) ?? String(valor ?? '');
}

export function montarPayload({
  slug,
  horarioId,
  plano,
  metodoPagamento,
  dadosBase,
  cartao,
  socialDocumentUrl,
  socialDocumentNote,
  socialDocumentMimeType,
  termsAccepted = true,
  cupom,
}) {
  const payload = {
    nome: dadosBase.nome?.trim() ?? '',
    email: dadosBase.email?.trim() ?? '',
    whatsapp: (dadosBase.whatsapp ?? '').replace(/\D/g, ''),
    cpf: (dadosBase.cpf ?? '').replace(/\D/g, ''),
    slug,
    horarioId,
    plano,
    paymentMethod: metodoPagamento === 'cartao' ? 'CREDIT_CARD' : 'PIX',
    termsAccepted,
    ...(socialDocumentUrl
      ? { socialDocumentUrl, socialDocumentNote, socialDocumentMimeType }
      : {}),
    ...(cupom ? { cupom } : {}),
  };

  if (metodoPagamento === 'cartao' && cartao?.numero) {
    const [mes = '', ano = ''] = (cartao.validade ?? '').split('/');
    payload.card = {
      holderName: cartao.nome?.trim() ?? '',
      number: cartao.numero.replace(/\s/g, ''),
      expiryMonth: mes,
      expiryYear: ano ? `20${ano}` : '',
      ccv: cartao.cvv ?? '',
    };
  }

  return payload;
}
